module.exports = __webpack_public_path__ + "static/media/evolution_93.eaeb9058.svg";